export default __webpack_public_path__ + "static/media/community.ef24220c.png";